<div class="applications-container">
  <button mat-icon-button (click)="scrollLeft()" aria-label="Scroll left" class="scroll-button">
    <mat-icon>chevron_left</mat-icon>
  </button>

  <div class="applications-wrapper" #appsWrapper>
    <div class="applications-grid">
      @for (app of apps; track $index) {
        <div class="app-card">
          @if (isExternalLink(app.route)) {
            <a [href]="app.route" target="_blank" rel="noopener noreferrer" class="app-link">
              <mat-card class="app-image-card dashboard-card" [matTooltip]="app.description"
                        matTooltipClass="custom-tooltip">
                <h5>{{ app.title }}</h5>
                <img alt="{{ app.title }}" [src]='app.image' class="app-image" />
              </mat-card>
            </a>
          } @else {
            <a [routerLink]="app.route" class="app-link">
              <mat-card class="app-image-card dashboard-card" [matTooltip]="app.description"
                        matTooltipClass="custom-tooltip">
                <h5>{{ app.title }}</h5>
                <img alt="{{ app.title }}" [src]='app.image' class="app-image" />
              </mat-card>
            </a>
          }
        </div>
      }
    </div>
  </div>

  <button mat-icon-button (click)="scrollRight()" aria-label="Scroll right" class="scroll-button">
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
